const API_BASE_URL = "https://creativekids-b.onrender.com";

export default API_BASE_URL;
